"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportFromProjectOverlay = exports.getStatusText = void 0;
exports.traverseSelected = traverseSelected;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_select_1 = require("react-select");
var FolderTree_1 = require("components/FolderTree");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var Types = require("types");
require("./index.scss");
var extractReturnType = Types.extractReturnType;
var mapStateToProps = function (state) { return ({
    import: state.files.import
}); };
var mapDispatchToProps = function (dispatch) { return ({
    changeExpand: function (expand, folder) {
        return dispatch(FilesActions.ImportFromProjectActions.copyChangeExpand(expand, folder));
    },
    selectItem: function (folder, value) {
        dispatch(FilesActions.ImportFromProjectActions.selectFile(folder, value));
    },
    selectProject: function (project) {
        return dispatch(FilesActions.importSetProject(project));
    },
    setStep: function (step) { return dispatch(FilesActions.importSetStep(step)); },
    fetchProjects: function () { return dispatch(FilesActions.importFetchProjectListRequest()); },
    getContent: function (parent) {
        return dispatch(FilesActions.ImportFromProjectActions.fetchTree(parent, ['FOLDER']));
    },
    fetchGroups: function (project) {
        return dispatch(FilesActions.importFetchGroupListRequest(project));
    },
    closeOverlay: function (folder) {
        dispatch(FilesActions.refreshFiles());
        dispatch(FilesActions.importClear());
        dispatch(FilesActions.ImportFromProjectActions.copyFilesReset());
        dispatch(FilesActions.ImportFromProjectActions.copyFilesToggleOverlay(Types.Reducer.CLOSED));
    },
    copyFiles: function (files, ignored, destination, groups) {
        dispatch(FilesActions.ImportFromProjectActions.copyFilesRequestAction('IMPORT', files, destination, ignored, groups));
    },
    userToggleCopyOrMoveResult: function () {
        dispatch(FilesActions.ImportFromProjectActions.userToggleCopyOrMoveResult());
        dispatch(FilesActions.importClear());
    },
    clear: function () {
        dispatch(FilesActions.importClear());
    }
}); };
var statePropsExtractable = extractReturnType(mapStateToProps);
var dispatchPropsExtractable = extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('ImportFromProject'), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('groupsSelected', 'setGroupsSelected', {}), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (this.props.import.step1.files.mode === 'CLOSED' &&
            this.props.import.step1.files.mode !== nextProps.import.step1.files.mode) {
            nextProps.fetchProjects();
        }
        if (nextProps.import.step1.files.mode !== 'CLOSED' &&
            nextProps.import.step1.project &&
            nextProps.import.step1.project !== this.props.import.step1.project) {
            nextProps.getContent({
                id: nextProps.import.step1.project.rootFolder,
                project: nextProps.import.step1.project.id
            });
            nextProps.fetchGroups(nextProps.import.step1.project);
        }
    }
}), recompose_1.pure);
function traverseSelected(node, selected, picked, ignored, parent) {
    if (selected === void 0) { selected = []; }
    if ((!parent || !parent.getSelected()) && node.getSelected() === true) {
        picked[node.getValue().id] = node;
        selected.push(node);
    }
    node.getChildren().reduce(function (prev, c) {
        var value = c.getValue();
        var p = c.getParentNode();
        if (!p || (prev[p.getValue().id] && c.getSelected() === true)) {
            // return prev
        }
        else if (ignored && c.getSelected() === false) {
            ignored[value.id] = c;
        }
        else {
            if (c.getSelected() === true) {
                prev[value.id] = c;
            }
        }
        traverseSelected(c, selected, prev, ignored, p);
        return prev;
    }, picked);
    return selected;
}
var getStatusText = function (mode, success, failure) {
    return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/import');
};
exports.getStatusText = getStatusText;
var steps = ['1', '2'];
exports.ImportFromProjectOverlay = enhance(function (props) { return (React.createElement(sok_ui_1.Overlay, { isOpen: props.import.step1.files.mode !== Types.Reducer.CLOSED, onClose: function () { return props.closeOverlay(props.targetFolder); } },
    React.createElement(sok_ui_1.SideMenu, { className: 'sok-import-from-project', isOpen: props.import.step1.files.mode !== Types.Reducer.CLOSED, docked: false, orientation: 'right' },
        React.createElement(sok_ui_1.Header, { onClose: function () { return props.closeOverlay(props.targetFolder); } }, props.import.step1.files.mode === 'IMPORT'
            ? (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusImport')
            : (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusCopy')),
        React.createElement(sok_ui_1.Container, null,
            props.import.step1.files.status === 'STANDBY' && (React.createElement(sok_ui_1.StepBar, { showStepText: false, steps: steps, currentStep: parseInt(props.import.currentStep, 10) - 1 })),
            props.import.step1.files.status !== 'STANDBY' && (React.createElement("div", { className: "loading-spinner" },
                React.createElement(sok_ui_1.RequestSpinner, { isLoading: props.import.step1.files.status === 'COPYING', success: props.import.step1.files.status === 'SUCCESS' }))),
            (props.import.step1.files.status === 'SUCCESS' ||
                props.import.step1.files.status === 'FAILURE') && (React.createElement("div", { className: 'result-information' },
                React.createElement("div", { className: 'result-text' },
                    (0, exports.getStatusText)(props.import.step1.files.mode, props.import.step1.files.status === 'SUCCESS', props.import.step1.files.status === 'FAILURE'),
                    ' ',
                    props.import.step1.files.data.tree &&
                        props.import.step1.files.data.tree
                            .getNodes()
                            .filter(function (f) { return f.getSelected(); }).length,
                    ' ',
                    (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/itemsTo'),
                    ' ',
                    props.targetFolder ? props.targetFolder.name : ''),
                React.createElement(sok_ui_1.Button, { style: { marginRight: '20px' }, color: props.import.step1.files.status === 'SUCCESS'
                        ? 'base-green'
                        : 'red', className: 'ok-button', onClick: function () {
                        if (props.import.step1.files.status === 'SUCCESS') {
                            return props.closeOverlay(props.targetFolder);
                        }
                    }, text: props.import.step1.files.status === 'SUCCESS'
                        ? "".concat((0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/submitOk'))
                        : "".concat((0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/submitFailed')) }))),
            props.import.step1.files.status !== 'SUCCESS' &&
                props.import.step1.files.status !== 'FAILURE' &&
                props.import.currentStep === '1' &&
                (function () {
                    return (React.createElement("div", null,
                        React.createElement(react_select_1.default, { menuPlacement: 'auto', classNamePrefix: 'react-select', className: 'project-select', id: 'import-from-project', options: props.import.step1.projectList, isMulti: false, getOptionValue: function (opt) { return opt.id; }, getOptionLabel: function (opt) { return opt.name; }, onChange: function (e) {
                                props.selectProject(e);
                            } }),
                        React.createElement("div", { className: props.import.step1.files.status !== 'STANDBY' ||
                                (props.import.step1.files.data.status === 'FETCHING' &&
                                    !props.import.step1.files.data.root)
                                ? 'centered'
                                : undefined },
                            props.import.step1.files.data.status === 'FETCHING' &&
                                !props.import.step1.files.data.root && (React.createElement("div", { className: 'loading-spinner' },
                                React.createElement(sok_ui_1.LoadingSpinner, null),
                                React.createElement("div", { className: "loadingText" }, (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/fetchingContent')))),
                            props.import.step1.files.data.root !== null &&
                                props.import.step1.files.data.root.getChildren().length ===
                                    0 &&
                                props.import.step1.files.status === 'STANDBY' &&
                                props.import.step1.project && (React.createElement("div", { className: 'result-information' },
                                React.createElement("div", { className: 'result-text' }, (0, translation_1.getLocalization)('userfront/project/ImportFromProjectOverlay/noFiles')))),
                            props.import.step1.files.data.tree !== null &&
                                props.import.step1.files.status === 'STANDBY' &&
                                props.import.step1.project && (React.createElement(FolderTree_1.default, { perm: props.import.step1.project.perm || 0x00, parentIdentifier: props.import.step1.project.rootFolderIdentifier, tree: props.import.step1.files.data.tree, selectItem: props.selectItem, changeExpand: props.changeExpand, getContent: props.getContent })))));
                })(),
            props.import.step1.files.status === 'STANDBY' &&
                props.import.currentStep === '2' && (React.createElement("div", { className: 'step2' },
                React.createElement("h3", null, (0, translation_1.getLocalization)('userfront/project/ImportFromProject/userGroups')),
                React.createElement(sok_ui_1.Table.Table, { className: 'project-folder-permission-list striped' },
                    React.createElement(sok_ui_1.Table.Body, null, props.import.step2.groupsList.map(function (g) { return (React.createElement(sok_ui_1.Table.Row, { className: 'category-row', key: "category-".concat(g.id) },
                        React.createElement(sok_ui_1.Table.Column, null,
                            React.createElement(sok_ui_1.Input, { type: 'checkbox', label: '', onChange: function () {
                                    var selected = __assign({}, props.groupsSelected);
                                    if (selected[g.id]) {
                                        delete selected[g.id];
                                    }
                                    else {
                                        selected[g.id] = g;
                                    }
                                    props.setGroupsSelected(selected);
                                }, value: props.groupsSelected[g.id] })),
                        React.createElement(sok_ui_1.Table.Column, null, g.name))); })))))),
        React.createElement(sok_ui_1.Footer, null,
            (props.import.currentStep === '2' &&
                props.import.step1.files.status === 'STANDBY') ||
                props.import.step1.files.status === 'FAILURE' ? (React.createElement(sok_ui_1.Button, { color: 'base-green', disabled: props.import.step1.files.status !== 'STANDBY', onClick: function () {
                    if (props.import.step1.files.data.tree) {
                        var picked = {};
                        var ignored = {};
                        var selected = traverseSelected(props.import.step1.files.data.tree.getRoot(), [], picked, ignored);
                        props.copyFiles(selected, Object.values(ignored), props.targetFolder, props.import.step2.groupsList.filter(function (g) { return !!props.groupsSelected[g.id]; }));
                    }
                }, text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/save') })) : props.import.step1.files.status === 'STANDBY' ? (React.createElement(sok_ui_1.Button, { color: 'blue', disabled: !(props.targetFolder &&
                    props.import.step1.project &&
                    props.import.step1.files.data.tree &&
                    props.import.step1.files.data.tree
                        .getNodes()
                        .find(function (f) { return f.getSelected() === true; })), onClick: function () {
                    props.setStep('2');
                }, text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/continue') })) : null,
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: function () { return props.closeOverlay(props.targetFolder); }, disabled: props.import.step1.files.status === 'COPYING', text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/cancel') }))))); });
